import React, { useState } from 'react';
import {
    EDPageBackground,
    EDPageContainer,
    EDPageContent,
    EDPageParallaxBackground,
    IEDPageParallaxBackgroundImage
} from "@trailblazer-game/ed-webkit";
import { styled } from "@mui/material/styles";

export interface IPageLayoutProps {
    children: React.ReactNode | React.ReactNode[]
    className?: string
    backgroundImage?: string
    backgroundImages?: IEDPageParallaxBackgroundImage[]
    title?: string;
    backgroundColor?: string;
    justifyContent?: string;
}

function PageLayout(props: IPageLayoutProps) {
    return (
        <EDPageContainer>
            {props.backgroundImage ? <EDPageBackground src={props.backgroundImage || ""} in={true} /> : <></>}
            {props.backgroundImages ? <EDPageParallaxBackground images={props.backgroundImages || []} in={true} title={props.title || ""} /> : <></>}
            <EDPageContent sx={{backgroundColor: props.backgroundColor || 'rgba(0,0,0,0.5)'}} justifyContent={props.justifyContent || 'center'}>
                {props.children}
            </EDPageContent>
        </EDPageContainer>
    );
}


// Default style!
const PageLayoutStyled = styled(PageLayout)({
});

// Export
export default PageLayoutStyled;
